export const ANTD_INITIATIVES_STATUS_COLORS = {
	BLUE: '#0000ff',
	GREEN: '#008000',
	ORANGE: '#ffa500'
};
